import { useParams } from "react-router-dom";
import { useApi } from "@/lib/useApi";
import { VideoGrid } from "@/components/VideoRow";

export default function DanceStyleDetail() {
  const { slug } = useParams();
  const { data, error } = useApi(`/dance-styles/${slug}`);
  if (error) return <p className="mt-16 text-[16px] text-[#8A8A8A]">Dance style not found.</p>;
  if (!data) return null;
  return (
    <section className="mt-8 md:mt-10 lg:mt-12 df-fade-up" data-testid="dance-style-detail-page">
      <h1 className="text-[22px] md:text-[26px] lg:text-[28px] 4xl:text-[34px] font-bold leading-tight mb-5 md:mb-7" data-testid="dance-style-title">
        {data.name}
      </h1>
      {data.videos.length ? <VideoGrid videos={data.videos} /> : <p className="text-[16px] text-[#8A8A8A]">No videos in this style yet.</p>}
    </section>
  );
}
